import { NetworkClient } from "@kosmod/pancake";
import { LocalStorageService } from "../hooks";
import { Logger } from "@kosmod/kit";
import { v2 } from "@lukekaalim/act-router"
import { createContext } from "@lukekaalim/act";

/**
 * Interfaces available to the frontend,
 * as a function of the platform
 */
export type FrontendPlatform = {
  storage: LocalStorageService,
  net: NetworkClient,
  logger: Logger,
  router: v2.URLRouter
};

export const FrontendPlatformContext = createContext<FrontendPlatform | null>(null);